import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import FeedbackForm from './FeedbackForm';
import Plan from './Plan';
import UserCondition from './UserCondition.js';

import ContactModal from './ContactModal';
import { LinkContainer } from "react-router-bootstrap";


import './content/content.css';

class Plans extends Component {

	constructor() {
		super();
		this.state = {
            contactModalVisible: false, 
            fa: "", 
			contactModalTopic: "", 
			contactModalCue: "",
			contactModalPush: "",
			messageInputCollapsed: false
		};

		this.handleContactUsPricingClick = this.handleContactUsPricingClick.bind(this);
		this.handlePlanDedicatedClick = this.handlePlanDedicatedClick.bind(this);
		this.handleHideContactModal = this.handleHideContactModal.bind(this);
	}

	handleHideContactModal() {
		this.setState({contactModalVisible: false});
	}

	handleContactUsPricingClick() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery Search Pricing", 
			messageInputCollapsed: false
		});
	}		

	handlePlanDedicatedClick() {
		this.setState({contactModalVisible: true, fa: "fa-envelope-open-o", contactModalTopic: "Webfinery Search Dedicated", 
			messageInputCollapsed: false
		});
	}	

	render() {
		return (
	      <div>

	      	<Grid fluid={true} style={{maxWidth: "80%"}}>
	      		<Row>
	      			<Col md={12}>
	      				<h1>Plans<br /> <small>Search the source code of the web</small></h1>
				      	<h5>No credit card required to get started</h5>
	      			</Col>
	      		</Row>
				<Row className="small-gutter">
				
				<Col md={4}>
					<Plan className="plan-basic" name="basic" subtitle="top sites" price="Free" dataSet="Basic" export="Limited" depth="Front page">
						<UserCondition isLoggedIn={true}>
							<Button bsStyle="default" disabled>Your current plan</Button>
						</UserCondition>
						<UserCondition isLoggedIn={false}>
							<LinkContainer to={"/signup?plan=basic"}>
						     	<Button bsStyle="success">Sign up</Button>
						     </LinkContainer>							
						</UserCondition>
					</Plan>
				</Col>

				<Col md={4}>
					<Plan className="plan-pro" name="pro" subtitle="top sites & tail" price="$49 / month" dataSet="Large" export="Extended" depth="Front page">
						<FeedbackForm submitLabel="Beta access" list="upgrade-pro" doneMessage="Please await an email from us."></FeedbackForm>
					</Plan>
				</Col>

				<Col md={4}>
					<Plan className="plan-dedicated" name="dedicated" subtitle="any sites" price="Contact us" dataSet="Unlimited" export="Unlimited" depth="Unlimited">
				     	<Button bsStyle="success" onClick={this.handlePlanDedicatedClick}>Contact us</Button>
					</Plan>
				</Col>

			</Row>

	      		<Row>
	      			<Col md={12}>
	      				<h5>Questions about the plans and pricing?</h5>
	      				<Button onClick={this.handleContactUsPricingClick}>Contact us</Button>
	      			</Col>
				</Row>	      		
	      	</Grid>
			<ContactModal fa={this.state.fa} topic={this.state.contactModalTopic} message={this.state.contactModalMessage} 
    				contactModalCue={this.state.contactModalCue} contactModalPush={this.state.contactModalPush} 
    				visible={this.state.contactModalVisible} handleHide={this.handleHideContactModal} 
    				submittedLabel={this.state.contactModalSubmittedLabel}/>
	      </div>
		)
	}
}

export default Plans;


// WEBPACK FOOTER //
// ./src/Plans.js